const VK = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13612_122886)">
      <rect width="40" height="40" fill="#0077FF" />
      <path
        d="M21.5333 28.65C12.4166 28.65 7.21668 22.4 7 12H11.5667C11.7167 19.6333 15.0833 22.8666 17.7499 23.5333V12H22.0501V18.5833C24.6834 18.3 27.4497 15.3 28.3831 12H32.6832C31.9665 16.0667 28.9665 19.0666 26.8332 20.3C28.9665 21.3 32.3834 23.9166 33.6834 28.65H28.9499C27.9332 25.4833 25.4001 23.0333 22.0501 22.7V28.65H21.5333Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13612_122886">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { VK };
